export default __webpack_public_path__ + "static/media/26t.217f8f56.jpg";